import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get Recipe List
export const getRecipeList = createAsyncThunk(
  "getRecipeList",
  async (
    { search, pageLimit, pageCount, sort_by, sort_direction },
    { rejectWithValue }
  ) => {
    try {
      let queryParams = [];

      if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
      if (pageCount) queryParams.push(`page=${pageCount}`);
      if (pageLimit) queryParams.push(`limit=${pageLimit}`);
      if (sort_by) queryParams.push(`sortBy=${sort_by}`);
      if (sort_direction) queryParams.push(`sortOrder=${sort_direction}`);

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await AxiosApi.get(`nutrition/get-recipe${queryString}`);
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Something went wrong"
      );
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

// Create Edit Recipe
export const createRecipe = createAsyncThunk(
  "createRecipe",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`nutrition/add-recipe`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// update Recipe
export const updateRecipe = createAsyncThunk(
  "updateRecipe",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`nutrition/update-recipe`, payload);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message);
      return rejectWithValue(error.response?.data);
    }
  }
);

// Delete Recipe
export const deleteRecipe = createAsyncThunk(
  "deleteRecipe",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`nutrition/delete-recipe/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const recipeSlice = createSlice({
  name: "recipes",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // Get Recipe
      .addCase(getRecipeList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRecipeList.fulfilled, (state, action) => {
        state.loading = false;
        state.getRecipeListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getRecipeList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = recipeSlice;
export default reducer;
